export enum BoardType {
    DAILY_WORK = `0127b178-e56a-4b97-913b-4ea78e511864`,
    PROJECT = `aaa7004a-55cf-4ce1-bc2e-1230962ab7e7`,
    AGGREGATION = `5b0b0a42-4bf9-4bb0-9813-bcce2b118d3a`,
}